import Tabs from '../../js/src/tabs.js';
import { scrollToY } from '../../js/helpers';
import { throttle } from "throttle-debounce";


(function ($) {

    // > 1440px we want tab heights to match
    function equalTabHeights(divs) {
        const mq = window.matchMedia("(min-width: 1440px)");

        if (mq.matches) {
            let minHeight = 0;

            divs.each(function(index, div) {

                let wasHidden = false;
                // to get the height of a display:none (not active) tab, we need to show it briefly...
                if ($(div).is(':hidden')) {
                    $(div).show();
                    wasHidden = true;
                }

                const thisHeight = $(div).find('.card-grid').outerHeight();

                if (thisHeight > minHeight) {
                    minHeight = thisHeight;
                }
                // and hide it again if it was hidden
                if (wasHidden) {
                    $(div).hide();
                }

            })
                .css('min-height', minHeight);
        } else {
            divs.css('min-height', 'initial');
        }
    }

    $(document).ready(function () {

        let $what = $('.whats-on');

        if($what.length) {

            $what.each(function(index, tab) {
                const tabContent = $(tab).find('.whats-on__stage');

                // only do this if more than one feed type being used
                if(tabContent.length > 1) {
                    // match heights of tabs
                    equalTabHeights(tabContent, tab);

                    $(window).on('resize', throttle(100, () => {
                        equalTabHeights(tabContent, tab)
                    }));

                    new Tabs($(tab), false, 0);

                    $(tab).bind('easytabs:before', (e) => {
                        const tabY = $(tab).position().top;
                        if (window.scrollY >= tabY) {
                            scrollToY(tabY, 300);
                        }

                        equalTabHeights(tabContent);
                    });
                }

            });
        }

    });

})(jQuery);